
import { 
  Award,
  ShieldCheck, 
  LineChart, 
  Clock, 
  HomeIcon, 
  LayoutList
} from "lucide-react";
import { Card } from "@/components/ui/card";
import { motion } from "framer-motion";

const Features = () => {
  const features = [
    {
      icon: <Award className="w-10 h-10 text-corporate-secondary-100" strokeWidth={1.5} />,
      title: "Automated Crypto Trading",
      description: "Let experts trade for you 24/7, removing stress and emotion.",
    },
    {
      icon: <ShieldCheck className="w-10 h-10 text-corporate-secondary-100" strokeWidth={1.5} />,
      title: "Verified & Professional",
      description: "Every pro strategy is vetted and run by expert strategy providers with proven track record.",
    },
    {
      icon: <LineChart className="w-10 h-10 text-corporate-secondary-100" strokeWidth={1.5} />,
      title: "Transparent Performance",
      description: "Track results with real-time data and clear historical performance.",
    },
    {
      icon: <Clock className="w-10 h-10 text-corporate-secondary-100" strokeWidth={1.5} />,
      title: "Quick Start",
      description: "Easy sign-up in minutes to start trading immediately.",
    },
    {
      icon: <HomeIcon className="w-10 h-10 text-corporate-secondary-100" strokeWidth={1.5} />,
      title: "Swiss Made Quality",
      description: "Built in Switzerland, offering world-class quality and security.",
    },
    {
      icon: <LayoutList className="w-10 h-10 text-corporate-secondary-100" strokeWidth={1.5} />,
      title: "Real-time Monitoring",
      description: "Powering pro strategies with professional oversight.",
    },
  ];

  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  
  const item = {
    hidden: { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0, transition: { duration: 0.5 } }
  };

  return (
    <section className="py-20 px-4 bg-corporate-neutral-25">
      <div className="container mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-corporate-primary-75 mb-4">
            Why METRADE is the Best Choice
          </h2>
          <p className="text-corporate-neutral-75 text-lg max-w-2xl mx-auto">
            Professional trading strategies powering your investments
          </p>
        </motion.div>
        
        <motion.div 
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
        >
          {features.map((feature, i) => (
            <motion.div key={i} variants={item}>
              <Card 
                className="bg-corporate-primary-100 p-8 rounded-2xl border-none text-center hover:shadow-xl transition-all duration-300 hover:-translate-y-2 h-full flex flex-col items-center justify-center"
              >
                <div className="bg-corporate-primary-75 rounded-full p-5 mb-6 shadow-lg">
                  {feature.icon}
                </div>
                <h3 className="text-lg text-corporate-white font-medium leading-tight mb-4">
                  {feature.title}
                </h3>
                <p className="text-corporate-white/80 text-base leading-relaxed">
                  {feature.description}
                </p>
              </Card>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Features;
